import Accepted from "./Accepted"
import AwaitingModeration from "./AwaitingModeration"
import AwaitingUpload from "./AwaitingUpload"
import NotAccepted from "./NotAccepted"
import Pending from "./Pending"
import QuotaFull from "./QuotaFull"
import Rejected from "./Rejected"
import Tutorial from "./Tutorial"

const MissionItemTypes = {
  awaitingModeration: AwaitingModeration,
  awaitingUpload: AwaitingUpload,
  notAccepted: NotAccepted,
  pending: Pending,
  quotaFull: QuotaFull,
  rejected: Rejected,
  accepted: Accepted,
  tutorial: Tutorial
}

export default MissionItemTypes
